import ContinueSection from "@Components/game/playlists/continue/continue-section";
import HighlightedPlaylist from "@Components/game/playlists/highlighted/higlighted-playlist";
import ContainerWrapper from "@Components/generic/container-wrapper";
import Icon from "@Components/generic/icon";
import ScrollfulContainer from "@Components/generic/scrollful-container";
import { PlaylistsProvider, usePlaylistsContext } from "@Context/game/playlists/playlists-context";
import { faTrafficCone } from "@fortawesome/pro-regular-svg-icons";
import useI18n from "@i18n";
import { Box, Stack, Typography, useTheme } from "@mui/material";

const PageId = "Playlists";

const PlaylistsContent = () => {
  const theme = useTheme();
  const { i18n } = useI18n();
  const { playlists, loading } = usePlaylistsContext();
  const isEmpty = !loading && playlists && playlists?.length === 0;

  return (
    <ContainerWrapper id={PageId} sx={{ overflow: "visible" }} fullHeight>
      <ScrollfulContainer maxWidth={false} disableGutters sx={{ padding: theme.spacing(0, 0, 6) }}>
        {!isEmpty ? (
          <Stack spacing={6}>
            <HighlightedPlaylist />
            <ContinueSection />
            {/* <FeaturedSection /> */}
            {/* <CategoriesSection /> */}
            {/* <RecentlyPlayedSection /> */}
          </Stack>
        ) : (
          <Box display="flex" justifyContent="center" alignItems="center" textAlign="center" height="100%" flexDirection="column" gap={2}>
            <Icon icon={faTrafficCone} size="5x" sx={{ color: "dsBase.v200" }} />
            <Typography variant="text2xl600" color="dsBase.v200">
              {i18n("playlists.list.empty")}
            </Typography>
          </Box>
        )}
      </ScrollfulContainer>
    </ContainerWrapper>
  );
};

const Playlists = () => {
  return (
    <PlaylistsProvider>
      <PlaylistsContent />
    </PlaylistsProvider>
  );
};

export default Playlists;
